<div class="freeze-content pointer-events-none" *ngIf="!isSeparateZone; else separateZoneTemplate">
  <div
    class="widget-box"
    (click)="onFreezeCard()"
    [ngClass]="{
      'is-workflow': isWorkflow,
      'disable-widget': isWidgetDisabled,
      'card-freezed': isFreezeCard
    }"
  >
    <div class="widget-icon" [ngStyle]="borderStyle">
      <mat-icon class="freeze-icon" svgIcon="freeze-card"></mat-icon>
    </div>
    <label class="label" for="title" [ngStyle]="textContentStyle" [ngClass]="{ 'is-workflow': isWorkflow }">
      {{ cardLabel }}
    </label>
  </div>
</div>

<ng-template #separateZoneTemplate>
  <div
    class="freeze-content separate-zone pointer-events-none"
    [ngStyle]="contentStyle"
    style="height: 98%"
    [ngClass]="{
      'disable-widget': isWidgetDisabled
    }"
  >
    <div class="list-box" [ngClass]="isFreezeCard ? 'card-freezed' : ''" (click)="onFreezeCard()">
      <div class="l-section">
        <div class="image">
          <mat-icon class="freeze-icon" svgIcon="freeze-card"></mat-icon>
        </div>
      </div>
      <div class="center-section" style="width: 100%">
        <div class="title">{{ cardLabel }} Card</div>
        <div class="sub-title">Instant card freeze/Unfreeze for security</div>
      </div>
    </div>
  </div>
</ng-template>
